import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import { hexEncode, scrambleWithKey, toUTF8 } from 'sharedreact/utils/Encode';

import OpenIDConfigConnection from 'workspaces/launcher/connections/OpenIDConfigConnection';
import OpenIDConfigConstants from 'workspaces/launcher/constants/OpenIDConfigConstants';
import OpenIDConfig from 'workspaces/launcher/data/OpenIDConfig';

const _privKey: number = 89234567;

function handleFetchSuccess (items: Immutable.List<OpenIDConfig>) {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.GET_SUCCESS,
    items: items,
    logLevel: 'trace'
  });
}

function handleFetchFailure (error: ErrorData) {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.GET_FAILURE,
    error: error,
    logLevel: 'trace'
  });
}

function fetch () {
  OpenIDConfigConnection.fetch(handleFetchSuccess, handleFetchFailure);
}

function _onSaveSuccess (openIDConfig: OpenIDConfig): void {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.SAVE_SUCCESS,
    item: openIDConfig,
    logLevel: 'trace'
  });
}

function _onSaveError (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.SAVE_FAIL,
    error: error,
    logLevel: 'trace'
  });
}

function save (openIDConfig: OpenIDConfig): void {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.SAVE,
    item: openIDConfig.set('clientSecret', '').set('isClientSecretEdited', false), // don't send client secret in an action
    logLevel: 'debug'
  });

  OpenIDConfigConnection.save(
    openIDConfig.set('clientSecret', hexEncode(scrambleWithKey(toUTF8(openIDConfig.clientSecret), _privKey))),
    _onSaveSuccess,
    _onSaveError
  );
}

function _removeSuccess (ids: Immutable.Set<string>): void {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.REMOVE_SUCCESS,
    ids: ids,
    logLevel: 'debug'
  });
}

function _removeError (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.REMOVE_FAIL,
    error: error,
    logLevel: 'trace'
  });
}

function remove (ids: Immutable.Set<string>): void {
  AppDispatcher.dispatch({
    actionType: OpenIDConfigConstants.REMOVE,
    ids: ids,
    logLevel: 'debug'
  });

  OpenIDConfigConnection.remove(ids, _removeSuccess, _removeError);
}

const OpenIDConfigActions = {
  fetch,
  save,
  remove
};

export default OpenIDConfigActions;
